import * as Yup from 'yup'

export const addressFormValues = (vendor = {}) => {
    return {
        address_type: "",
        shipping_first_name: vendor.first_name || "",
        shipping_middle_name: vendor.middle_name || "",
        shipping_last_name: vendor.last_name,
        shipping_company_name: vendor.company_name || "",
        shipping_address: "",
        shipping_address1: "",
        shipping_city: "",
        shipping_country: "",
        shipping_state: "",
        shipping_zipcode: "",
        shipping_phone: "",
        shipping_mobile: "",
        shipping_fax: "",
    }
}

export const addressFormVS = Yup.object({
    address_type: Yup.string().required("This field is required"),
    shipping_first_name: Yup.string().required("This field is required"),
    shipping_company_name: Yup.string().required("This field is required"),
    shipping_last_name: Yup.string().required("This field is required"),
    shipping_address: Yup.string().required("This field is required"),
    shipping_city: Yup.string().required("This field is required"),
    shipping_country: Yup.string().required("This field is required"),
    shipping_state: Yup.string().required("This field is required"),
    shipping_mobile: Yup.string()
        .required("This field is required")
        .min(8, 'Invalid number')
        .max(12, 'Invalid number')
})